import {TooltipItemType} from 'common/components/chart-tooltip/types';

export const chartTooltipSections = [
  {
    rows: [
      {
        items: [{text: `Kittens`, type: TooltipItemType.Strong}],
      },
    ],
  },
  {
    rows: [
      {
        items: [
          {text: `10%`, type: TooltipItemType.Data},
          {text: `love to take baths`, type: TooltipItemType.Text},
        ],
      },
      {
        items: [
          {text: `100`, type: TooltipItemType.Data},
          {text: `kittens`, type: TooltipItemType.Text},
        ],
      },
    ],
  },
];
